export { SimpleCarousel } from "./SimpleCarousel";
